import router from './router'
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = '企业中心-' + to.meta.title
    next()
  }
})